import React from 'react';
import withIcon from '../utilities/withIcon';

const IconAirplane = () => {
  return (
    <g>
      <path d="m15.996.82-.016.102-2.926 12.534a1.25 1.25 0 0 1-1.765.84l-.12-.066-2.031-1.275-2.214 2.603a1.25 1.25 0 0 1-2.196-.682l-.006-.128-.001-4.567L.586 7.584a1.25 1.25 0 0 1 .109-2.178l.117-.05L14.985.048a.75.75 0 0 1 1.011.77zM6.221 11.122v2.946l1.633-1.92-1.633-1.026zm7.72-8.075L6.897 9.775l4.774 2.998 2.27-9.726zm-1.839-.317L1.812 6.582l3.775 2.37 6.515-6.222z" />
    </g>
  );
};

export default withIcon(IconAirplane);
